import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ViewProjectHeaderWrapper = styled.div`
  display: flex;
  align-items: center;

  .header-container {
    display: flex;
    width: 100%;
    justify-content: space-between;

    ${responsive.MOBILE`
      display: flex;
      flex-direction: column;
      width: 100%;
    `}
  }

  .button-group {
    align-self: center;
    ${responsive.MOBILE`
        display: flex;
        flex-direction: column-reverse;
        gap: 16px;
        width: 100%;
        padding: 0px 0px 16px 0px;
    `}
  }

  .header-edit-button {
    margin-left: 16px;
    ${responsive.MOBILE`
       margin-left: 0px;
    `}
  }
`;
